import { useTranslation } from 'next-i18next'
import { useMemo } from 'react'

export default function PluginTooltip ({ compatibilities }) {
  const { t } = useTranslation(['common', 'applications', 'plugins'])
  const uniqueCompatibilities = useMemo(() => (
    [...new Set(compatibilities.map(compatibility => compatibility.software))]
  ))

  return (
    <div>
      <strong className="text-dark">{t('detail.compatible_with', { ns: 'plugins' })}</strong>
      <ul className="list-unstyled">
        {
          uniqueCompatibilities.map((compatibility, key) => (
            <li
              key={key}
              className="py-1"
            >
              <span className="d-flex align-items-center">
                <div
                  className="flex-shrink-0 d-flex align-items-center justify-content-center rounded-circle bg-primary"
                  style={{ width: '22px', height: '22px' }}
                >
                  <svg
                    viewBox="0 0 24 24"
                    height="11"
                    width="11"
                    xmlns="http://www.w3.org/2000/svg"
                    strokeWidth="4"
                  >
                    <path
                      d="M23.25.749,8.158,22.308a2.2,2.2,0,0,1-3.569.059L.75,17.249"
                      fill="none"
                      stroke="white"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                    </path>
                  </svg>
                </div>
                <span className="ms-2 text-dark">
                  {t(compatibility, { ns: 'applications' })}
                </span>
              </span>
            </li>
          ))
        }
      </ul>
    </div>
  )
}
